export const race = [
  "African",
  "Caucasian (European/West Asian/South Asian)",
  "East Asian",
  "Indigenous (Americas/Oceania)",
  "Mixed/Multiracial",
];
